module.exports = __webpack_public_path__ + "static/img/zljx.a8a18deb.png";